import {base64ToUint8Array} from '../../../utils/arrayUtils';

export default function channelIdFromParam(channelId?: string | null): Uint8Array | null {
  return channelId ? base64ToUint8Array(decodeURIComponent(channelId)) : null;
}